import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";



export const percentageBasedFields = `
id
percentageUniqueId
billingPercentage
billingPercentageDescription
`


export const CREATE_PERCENTAGE_SCHEME = gql`
  mutation CreatePercentageScheme($input: PercentageSchemeInputObjects!) {
    createPercentageScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${percentageBasedFields}
      }
    }
  }
`

export const UPDATE_PERCENTAGE_SCHEME = gql`
  mutation UpdatePercentageScheme($input: PercentageSchemeInputObjects!) {
    updatePercentageScheme(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${percentageBasedFields}
      }
    }
  }
`

export const DELETE_PERCENTAGE_SCHEME = gql`
  mutation DeletePercentageScheme($percentageUniqueId: String!) {
  deletePercentageScheme(percentageUniqueId: $percentageUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`

export const GET_PERCENTAGE_SCHEME = gql`
  query GetInstitutionServicePercentageSchemes($billingUniqueId: String) {
    getInstitutionServicePercentageSchemes(billingUniqueId: $billingUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${percentageBasedFields}
      }
    }
  }
`
export const CITIZEN_GET_INSTITUTION_SERVICE_PERCENTAGE_SCHEME = gql`
  query CitizenGetInstitutionServicePercentageSchemes($billingUniqueId: String) {
    citizenGetInstitutionServicePercentageSchemes(billingUniqueId: $billingUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${percentageBasedFields}
      }
    }
  }
`;

